<template functional>
  <footer
    class="the-footer flex-wrap flex-col flex my-2  p-0"
    :class="classes"
  >
    <span class="relative text-center">
      &copy; Leecom Scada Systems Pvt Ltd.
      <img
        class="leecom-logo"
        :src="require('@/assets/images/logo/leecom-logo.png')"
      />
    </span>
  </footer>
</template>

<script>
import { isMobile } from "mobile-device-detect";
export default {
  name: "the-footer",
  props: {
    classes: {
      type: String,
    },
  },
  data() {
    return {
      isMobile: isMobile,
    };
  },
};
</script>

<style scoped>
footer {
  display: block !important;
  margin: 0 auto;
  width: 400px;
}

.leecom-logo {
  position: absolute;
  top: -6px;
  /* right: -38px; */
}

.span {
}

.link,
span {
  color: #101010;
}

@media (max-width: 640px) {
  .the-footer {
    width: 100%;
    text-align: center;
  }

  .the-footer span {
    display: block;
  }
}
</style>